<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M3 6h3m2 0h13M3 10h3m2 0h13M3 14h3m2 0h13M3 18h3m2 0h13"/>
</svg>
